import type { CSSProperties } from 'react';

type Props = {
  color: string;
  size?: number;
  style?: CSSProperties;
};

export function SlaTypeDot({ color, size = 10, style }: Props) {
  return (
    <span
      aria-hidden
      style={{
        display: 'inline-block',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        flexShrink: 0,
        boxShadow: `0 0 0 2px ${color}22`,
        ...style,
      }}
    />
  );
}
